import { apiConstants, warehouseConstants, helperConstants } from '../_constants';
import APIService from "../_services/api";
import { userActions, helperActions } from '../_actions';

const getWarehouseConfigList = (data, _filter, _sorting, _paging, _first, _last, _type, message) => async dispatch => {
    data = { "p_param": { "method": "fetch_warehouse_config_list", "filter": _filter, "sorting": _sorting, "paging": _paging, "first": _first, "last": _last, "type": _type } }
    try {
        dispatch({
            type: apiConstants.API_START_CONTACTING
        })
        const res = await APIService.post('submit', data);

        if (res.data.error_msg === '') {

            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: message }
            })
            dispatch({
                type: warehouseConstants.WAREHOUSE_FETCH_COMPLETED,
                payload: res.data.out_record
            })
            dispatch({
                type: helperConstants.HELPER_UPDATE_PAGING,
                payload: { "currentpage": (_paging.currentpage === _paging.page || _paging.sizePerPage !== _paging.currentSizePerPage) ? 1 : _paging.page, "currentSizePerPage": _paging.sizePerPage }
            })
        } else {
            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: res.data.message }
            })
            if (res.data.status === 401) {
                dispatch(userActions.logout());

            }
        }
    }
    catch (e) {
        dispatch({
            type: apiConstants.API_END_CONTACTING,
            payload: { error_msg: 'contacting server failed' },
        })
    }

}


const updateWarehouse = (data) => dispatch => {
    dispatch({
        type: warehouseConstants.WAREHOUSE_SET_DATA, payload: data
    })
    dispatch({
        type: helperConstants.HELPER_MODE, payload: { "mode": 1 }
    })
}

const createWarehouse = () => dispatch => {
    dispatch({
        type: warehouseConstants.WAREHOUSE_SET_DATA, payload: { "warehouse_id": "", "config_name": "", "config_value": "", "notes": "" }
    })
    dispatch({
        type: helperConstants.HELPER_MODE, payload: { "mode": 0 }
    })
}

const onSelectWarehouse = (selected) => dispatch => {
    dispatch({
        type: warehouseConstants.WAREHOUSE_DELETE_DATA, payload: { selected }
    })

}

const saveWarehouseConfig = (_data, mode) => async dispatch => {
    let data = {}
    data = { "p_param": { "method": "save_warehouse_config", "data": _data, "mode": mode } }
    try {
        dispatch({
            type: apiConstants.API_START_CONTACTING
        })
        const res = await APIService.post('submit', data);

        if (res.data.error_msg === '') {
            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: helperConstants.HELPER_SUCCESSFULLY }
            })
            dispatch({
                type: warehouseConstants.WAREHOUSE_FETCH_COMPLETED,
                payload: res.data.out_record
            })
            dispatch(helperActions.showForm(false))
        } else {
            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: res.data.message }
            })
            if (res.data.status === 401) {
                dispatch(userActions.logout());

            }
        }
    }
    catch (e) {
        dispatch({
            type: apiConstants.API_END_CONTACTING,
            payload: { error_msg: 'contacting server failed' },
        })
    }

}

const deleteWarehouseConfig = (id, warehouse_id, config_name, _filters, _sorting, _paging, _first, _last, _type) => async dispatch => {

    let data = {}
    data = { "p_param": { "method": "delete_warehouse_config", "id": id, "warehouse_id": warehouse_id, "config_name": config_name } }
    try {
        dispatch({
            type: apiConstants.API_START_CONTACTING
        })
        const res = await APIService.post('submit', data);

        if (res.data.error_msg === '') {
            const resultJson = JSON.parse(res.data.out_record);
            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: resultJson.message }
            })

            dispatch(warehouseActions.getWarehouseConfigList({}, _filters, _sorting, _paging, _first, _last, _type, resultJson.message));
            dispatch(helperActions.showDialog(false))

        } else {
            dispatch({
                type: apiConstants.API_END_CONTACTING,
                payload: { error_msg: res.data.error_msg, message: res.data.message }
            })
            if (res.data.status === 401) {
                dispatch(userActions.logout());

            }
        }
    }
    catch (e) {
        dispatch({
            type: apiConstants.API_END_CONTACTING,
            payload: { error_msg: 'contacting server failed' },
        })
    }

}

export const warehouseActions = {
    getWarehouseConfigList,
    updateWarehouse,
    createWarehouse,
    onSelectWarehouse,
    saveWarehouseConfig,
    deleteWarehouseConfig
}